import _ from 'lodash'

export const sort = (list, columnKey, order) => {
  return [...list].sort((a, b) => {
    const sortOrder = order

    if (!a[columnKey] && !b[columnKey]) return 0
    if (!a[columnKey]) return sortOrder
    if (!b[columnKey]) return -(sortOrder)

    if (a[columnKey] < b[columnKey]) {
      return -(sortOrder)
    }

    if (a[columnKey] > b[columnKey]) {
      return sortOrder
    }

    return 0
  })
}

export const filter = (list, searchableFields, keyword) => {
  return _.filter(list, (item) => {
    const resultPerField = searchableFields.map((field) => {
      const filterKey = _.isString(keyword) ? keyword.toLowerCase() : ''
      const value = _.get(item, field)

      return !!(_.isString(value) && value.length > 0 && value.toLowerCase().includes(filterKey))
    })

    return resultPerField.includes(true)
  })
}
